import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import PropTypes from 'prop-types';
import AsyncCreatableSelect from 'react-select/async-creatable';
import { components } from 'react-select';
import { getRequest } from '../../../requestUtils';
import './CompanyRegistrationDropdown.scss';
var formatError = function formatError(error) {
  return error ? /*#__PURE__*/React.createElement("p", {
    className: "error-text"
  }, error) : '';
};
function MenuList(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(components.MenuList, props, Array.isArray(children) ? children.slice(0, 10) : children);
}
MenuList.propTypes = {
  children: PropTypes.arrayOf(PropTypes.node)
};
var companyOptions = function companyOptions(term) {
  return getRequest('/companies/autocomplete_dropdown', {
    term: term
  }).then(function (response) {
    return response.data.map(function (i) {
      return {
        label: i.domain ? "".concat(i.name, " <").concat(i.domain, ">") : i.name,
        value: i.name
      };
    });
  });
};
var CompanyRegistrationDropdown = /*#__PURE__*/function (_React$Component) {
  function CompanyRegistrationDropdown(props) {
    var _this;
    _classCallCheck(this, CompanyRegistrationDropdown);
    _this = _callSuper(this, CompanyRegistrationDropdown, [props]);
    _this.state = {
      menuOpen: false,
      value: props.value
    };
    _this.handleChange = _this.handleChange.bind(_this);
    return _this;
  }
  _inherits(CompanyRegistrationDropdown, _React$Component);
  return _createClass(CompanyRegistrationDropdown, [{
    key: "handleChange",
    value: function handleChange(e) {
      var onChange = this.props.onChange;
      var companyValue = e || {
        value: '',
        label: ''
      };
      this.setState({
        menuOpen: false,
        value: companyValue.value
      });
      if (onChange) {
        onChange(companyValue);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        error = _this$props.error,
        creatable = _this$props.creatable;
      var menuOpen = this.state.menuOpen;
      return /*#__PURE__*/React.createElement("div", {
        id: "company-dropdown",
        className: "company-select",
        onKeyUp: function onKeyUp() {
          _this2.setState({
            menuOpen: true
          });
        },
        onBlur: function onBlur() {
          _this2.setState({
            menuOpen: false
          });
        },
        role: "button",
        tabIndex: 0
      }, /*#__PURE__*/React.createElement(AsyncCreatableSelect, {
        id: "company",
        className: "company-select-dropdown ".concat(error ? 'error' : ''),
        name: "user[company_user_attributes][company_attributes][name]",
        classNamePrefix: "company-select",
        loadOptions: function loadOptions(input) {
          return companyOptions(input);
        },
        placeholder: "Company Name",
        onChange: this.handleChange,
        components: {
          MenuList: MenuList,
          IndicatorSeparator: function IndicatorSeparator() {
            return null;
          }
        },
        menuIsOpen: menuOpen,
        isValidNewOption: function isValidNewOption(opt) {
          return creatable && opt.length;
        },
        isClearable: true
      }), formatError(error));
    }
  }]);
}(React.Component);
CompanyRegistrationDropdown.propTypes = {
  error: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  creatable: PropTypes.bool
};
CompanyRegistrationDropdown.defaultProps = {
  error: null,
  value: null,
  onChange: null,
  creatable: true
};
export default CompanyRegistrationDropdown;